define('presentation/signup/viewModels/signupForCustomerModalViewModel',[
    'businessServices/signup/signupSessionStore',
    'common/promises/promiseFactory',
    'presentation/signup/common/signupNavigationManager',
    'presentation/signup/facades/signupForCustomerFacade',
    'presentation/signup/presentationObjects/affiliatePresentationObject',
    'presentation/signup/validators/signupForCustomerModalValidator'
], function() {

    return function() {
        let self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const AffiliatePresentationObjectConstructor = require('presentation/signup/presentationObjects/affiliatePresentationObject');

        let _facade = null;
        let _validator = null;
        let _disposables = [];
        let _signupNavigationManager = null;
        let _signupSessionStore = null;

        self.isCompositionComplete = ko.observable(false);
        self.affiliates = ko.observableArray([]);
        self.selectedAffiliate = ko.observable(null);
        self.hubSpotContactRecordId = ko.observable(null).extend({ rateLimit: 500 });
        self.hubSpotContact = ko.observable(null);
        self.patLiveAccountNumber = ko.observable(null).extend({ rateLimit: 500 });

        const _getHubSpotContact = (hubSpotContactRecordId) => {
            return _promiseFactory.defer((promise) => {
                _facade.getHubSpotContact(hubSpotContactRecordId)
                    .done((contact) => {
                        self.hubSpotContact(contact);
                        promise.resolve();
                    });
            });
        };

        const _handleAffiliateChanged = () => {
            _facade.saveAffiliateId(self.selectedAffiliate());
        };

        const _handleHubSpotContactChanged = () => {
            _facade.saveHubSpotContactRecordId(self.hubSpotContactRecordId());
        };

        const _handleHubSpotContactRecordIdChanged = (hubSpotContactRecordId) => {
            _getHubSpotContact(hubSpotContactRecordId)
                .done(() => {
                    _validateHubSpotContact();
                });
        };

        const _handlePatLiveAccountNumberChanged = () => {
            _facade.savePatLiveAccountNumber(self.patLiveAccountNumber());
        };

        const _prePopulateInputValues = (signupForCustomerPresentationObject) => {
            const { affiliateId, hubSpotContactRecordId, patLiveAccountNumber } = signupForCustomerPresentationObject;
            if (hubSpotContactRecordId) {
                self.hubSpotContactRecordId(hubSpotContactRecordId);
            }
            if (patLiveAccountNumber) {
                self.patLiveAccountNumber(patLiveAccountNumber);
            }
            const affiliate = self.affiliates().find((affiliate) => {
                return affiliate.affiliateCode === affiliateId;
            });
            if (affiliate) {
                self.selectedAffiliate(affiliate.affiliateCode);
            }
        };

        const _validateHubSpotContact = () => {
            self.hubSpotContact.validate();
        };

        self.detached = () => {
            _disposables.forEach(subscription => subscription.dispose());
            _disposables = [];
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/signup/facades/signupForCustomerFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ValidatorConstructor = require('presentation/signup/validators/signupForCustomerModalValidator');
            _validator = new ValidatorConstructor();

            const SignupNavigationManagerConstructor = require('presentation/signup/common/signupNavigationManager');
            _signupNavigationManager = new SignupNavigationManagerConstructor();
            _signupNavigationManager.init();

            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
            _signupSessionStore = new SignupSessionStoreConstructor();
            _signupSessionStore.init();

            return _initialize();
        };

        const _initialize = () => {
            _promiseFactory.deferIndefinitely(deferredObject => {
                _facade.getAffiliates()
                    .fail(deferredObject.reject)
                    .done((affiliates) => {
                        self.affiliates(affiliates);

                        const nonAffiliatePresentationObject = new AffiliatePresentationObjectConstructor();
                        nonAffiliatePresentationObject.displayName = "None";
                        self.affiliates.unshift(nonAffiliatePresentationObject);
                        self.selectedAffiliate(nonAffiliatePresentationObject);

                        _facade.loadSignupSession()
                            .fail(deferredObject.reject)
                            .done((signupForCustomerPresentationObject) => {

                                _prePopulateInputValues(signupForCustomerPresentationObject);

                                _validator.registerViewModel(self, _facade);

                                _disposables.push(self.selectedAffiliate.subscribe(_handleAffiliateChanged));
                                _disposables.push(self.hubSpotContactRecordId.subscribe(_handleHubSpotContactRecordIdChanged));
                                _disposables.push(self.hubSpotContact.isValid.subscribe(_handleHubSpotContactChanged));
                                _disposables.push(self.patLiveAccountNumber.isValid.subscribe(_handlePatLiveAccountNumberChanged));

                                deferredObject.resolve();
                            });
                    });
            });

            return _promiseFactory.wait();
        };
    };
});

